import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-2 font-mono text-[11px] font-medium tracking-[0.14em] uppercase " +
    "transition-colors",
  {
    variants: {
      variant: {
        // etiqueta de seção: "01 / Produto" — sem caixa, só tipografia
        section: "text-accent",
        // chip vivo (com pontinho): anúncios, status
        live:
          "rounded-full border border-line bg-surface px-4 py-1.5 normal-case tracking-normal font-sans text-xs text-muted-foreground",
        // tag técnica dentro de mocks
        tag: "rounded border border-accent/20 bg-accent-soft px-1.5 py-0.5 text-[10px] text-accent tracking-normal",
      },
    },
    defaultVariants: { variant: "section" },
  },
);

export interface BadgeProps
  extends ComponentProps<"span">,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
